/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatalistAnagrafica } from '@models';
import { UtenteService } from '@shared/services/utente.service';

@Component({
    selector: 'app-toolkit-utente-form-utente',
    templateUrl: './form-utente.component.html',
})
export class ToolkitGestioneUtenteFormComponent {
    
    @Input() formGroup: FormGroup;
    @Input() datalist: DatalistAnagrafica;

    constructor(
        public utenteService: UtenteService,
    ) { }

}
